module.exports = require("@getvim/components-atoms-booking-horizon-chip");